import {Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {ExamLogin} from '../exam-login/components/ExamLogin'
import {AuthLayout} from './AuthLayout'
import {Otp} from './components/Otp'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='exam' element={<ExamLogin />} />
      {/*<Route path='registration' element={<Registration />} />*/}
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='otp' element={<Otp />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
